module.exports = __webpack_public_path__ + "files/54276135c460d681cd627f09b707b823.svg";